import React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import FormNuevaCita from "./FormNuevaCita";
import { Toast,ToastContainer } from "react-bootstrap";
import { leadingZero, getAmpm, getHoraCita, convertirHoraMilitarA12h, convertirHoraEtiqueta, getElementosHora } from "../../../resources/Helper";
import CustomSwitch from "../custom/CustomSwitch";

function VistaPorUnidades(props) {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [recursos, setRecursos] = useState([]);
    const [todosLosRecursos, setTodosLosRecursos] = useState([]); // Lista completa sin filtrar
    const [recursosSeleccionados, setRecursosSeleccionados] = useState([]); // IDs de recursos seleccionados
    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const [alturaAgendaRecursos, setAlturaAgendaRecursos] = useState();
    const [bloquesMinutos, setBloquesMinutos] = useState();
    const [contenidoRecursos, setContenidoRecursos] = useState();
    const [etiquetasHoras, setEtiquetasHoras] = useState();

    const [fechaAgendaRecursos, setFechaAgendaRecursos] = useState();

    const [fechaUnix, setFechaUnix] = useState();
    const [stepCita, setStepCita] = useState();


    ////////////////////////////////////////////////////

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [modalState, setModalState] = useState('hidden');
    const [extendedProps, setExtendedProps] = useState({});
    const [idCita, setIdCita] = useState('');
    const [idPaciente, setIdPaciente] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [duracionCita, setDuracionCita] = useState('');
    const [estadoCita, setEstadoCita] = useState('');
    const [idEstadoCita, setIdEstadoCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [verCita, setVerCita] = useState(false);
    const [puedeAtender, setPuedeAtender] = useState('');
    const [idUsuarioAgenda, setIdUsuarioAgenda] = useState('');
    const [idUnidadAgenda, setIdUnidadAgenda] = useState('');
    const [primeraVez, setPrimeraVez] = useState();
    const [horaAtencionCita, setHoraAtencionCita] = useState();
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();
    const [profesionalAsignado, setProfesionalAsignado] = useState();
    const [usuarioAgenda, setUsuarioAgenda] = useState();
    const [nombreProfesionalAsignado, setNombreProfesionalAsignado] = useState('');
    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState('');
    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);

    ////////////////////////////////////////////////////


    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setStepCita(userdata.step);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });

        
        ////////////////////////////////

        crearBloquesMinutos(30,1.5);

        let fechaHoy = new Date();
        let dia = fechaHoy.getDate();
        let mes = fechaHoy.getMonth() + 1;
        let anyo = fechaHoy.getFullYear();

        let fechaAgenda = anyo+'-'+leadingZero(mes)+'-'+leadingZero(dia);

        setFechaAgendaRecursos(fechaAgenda);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                fecha: fechaAgenda
            }
        }

        /*axios.get('citas-unidades-dia', config2)
            .then(response => {
                if (response.status===200) {
                    setRecursos(response.data);
                }
            })
            .catch(error => console.log(error))
            */

        axios.get('citas-unidades-dia', config2)
            .then(response => {
                if (response.status===200) {
                    setTodosLosRecursos(response.data);
                    // Inicialmente seleccionar todas las unidades
                    const idsUnidades = response.data.map(unidad => unidad.id_unidad || unidad.id);
                    setRecursosSeleccionados(idsUnidades);
                    setRecursos(response.data);
                }
            })
            .catch(error => console.log(error))
        
        setFechaUnix(new Date().getTime());

    },[]);



    useEffect(() => {
        renderizarRecursos(30,1.5,recursos);
    },[recursos]);

    // Efecto para filtrar recursos cuando cambian las selecciones
    useEffect(() => {
        if (todosLosRecursos.length > 0) {
            const recursosFiltrados = todosLosRecursos.filter(unidad => 
                recursosSeleccionados.includes(unidad.id_unidad || unidad.id)
            );
            setRecursos(recursosFiltrados);
        }
    }, [recursosSeleccionados, todosLosRecursos]);


    useEffect(() => {
        cargarCitas(fechaAgendaRecursos);
    },[fechaAgendaRecursos]);

    
    function handleFecha(dias) {

        let c = dias*86400000;
        let nuevaFecha = new Date(fechaUnix + c);
        setFechaUnix(fechaUnix + c);

        let fc = new Date(fechaUnix + c);

        let dia = fc.getDate();
        let mes = fc.getMonth() + 1;
        let anyo = fc.getFullYear();

        setFechaAgendaRecursos(anyo+'-'+leadingZero(mes)+'-'+leadingZero(dia));
    }

    function handleFechaDirecta(fechaSeleccionada) {
        // Convertir la fecha seleccionada a timestamp Unix
        let fechaObj = new Date(fechaSeleccionada + 'T00:00:00');
        setFechaUnix(fechaObj.getTime());
        setFechaAgendaRecursos(fechaSeleccionada);
    }


    const handleClicCalendar = (e,citas) => {
        let rect = e.target.getBoundingClientRect();
        let y = (e.clientY - rect.top)-36; 
        let slot = parseInt(y/20);

        let minutoDia = stepCita*slot;

        let horaNuevaCita = parseInt((stepCita*slot)/60);
        let minutoNuevaCita = (slot*stepCita)%60;
        let fechaNuevaCita = leadingZero(horaNuevaCita)+':'+leadingZero(minutoNuevaCita)+':00';

        setDate(fechaAgendaRecursos);
        setHoraAtencionCita(getHoraCita(horaNuevaCita));
        setMinutoCita(leadingZero(minutoNuevaCita));
        setAmpmCita(getAmpm(horaNuevaCita));
        setUnidadAtencion(citas.id_unidad);

        setModalState('visible');
    }


    function renderizarRecursos(duracionBloque,minutosPorPixel,arrayCitas) {
        
        let h = parseInt(1440/minutosPorPixel);
        let duracionBloquePixels = parseInt(duracionBloque/minutosPorPixel);
        let alturaCalculada = h + 36; // Misma altura que el contenedor

        let citasJSX = [];

        arrayCitas.map((citas) => {
            let bloqueRecurso = <div className="columna-recursos" onClick={(e) => handleClicCalendar(e,citas)} style={{height: alturaCalculada + 'px'}}>
                                    <div className="encabezado-recurso">{citas.nombre_unidad}</div>
                                    {
                                        citas.citas.map((cita) => 
                                            <div className="cita-recursos" onClick={() => handleClicCita(cita)} style={{top:getPosYCita(cita,minutosPorPixel)+'px', height:getAlturaCita(cita,minutosPorPixel)+'px', backgroundColor:cita.color ? cita.color : '#c9c9c9'}}>{convertirHoraMilitarA12h(cita.hora_cita)} - {cita.primer_nombre} {cita.primer_apellido}</div>
                                        )
                                    }
                                </div>;
            citasJSX.push(bloqueRecurso);
        })

        setContenidoRecursos(citasJSX);
    }



    function getPosYCita(cita, minutosPorPixel) {
        let tiempoInicio = (60*parseInt(cita.hora_cita.split(':')[0])) + parseInt(cita.hora_cita.split(':')[1]);
        let posY = parseInt(tiempoInicio/minutosPorPixel);
        return posY+36;
    }

    function getAlturaCita(cita, minutosPorPixel) {
        let h = cita.duracion_cita;
        return parseInt(h/minutosPorPixel);
    }

    function crearBloquesMinutos(duracionBloque,minutosPorPixel) {

        let h = parseInt(1440/minutosPorPixel);
        let duracionBloquePixels = parseInt(duracionBloque/minutosPorPixel);
        let cantidadBloques = parseInt(h/duracionBloquePixels);
        let bloquesPorHora = 60/duracionBloque;

        setAlturaAgendaRecursos(h+36);

        let bloques = '';
        let etiquetas = '';

        for (let k=0;k<cantidadBloques;k++) {
            let estiloBloqueHora = '';
            let j = k+1;
            let i = j%bloquesPorHora;
            if (i==0) {
                let valorHora = (j*duracionBloque)/60;
                let posYEtiqueta = ((valorHora*duracionBloquePixels*(60/duracionBloque)) - 13) + 36;
                estiloBloqueHora = ' border-bottom: 1px solid #ddd;';
                if (valorHora<24) {
                    etiquetas += "<span class='etiqueta-hora' style='top: "+posYEtiqueta+"px'>"+convertirHoraEtiqueta(valorHora)+"</span>";
                }
            }
            bloques += "<div class='bloque-minutos' style='height:"+duracionBloquePixels+"px; "+estiloBloqueHora+"'></div>";
        }
        
        setEtiquetasHoras(etiquetas);
        setBloquesMinutos(bloques);
    }

    function cargarCitas(fecha) {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                fecha: fechaAgendaRecursos
            }
        }

        axios.get('citas-unidades-dia', config)
            .then(response => {
                if (response.status===200) {
                    console.log(response.data);
                    setTodosLosRecursos(response.data);
                    // Mantener selecciones actuales o seleccionar todas si es la primera carga
                    if (recursosSeleccionados.length === 0) {
                        const idsUnidades = response.data.map(unidad => unidad.id_unidad || unidad.id);
                        setRecursosSeleccionados(idsUnidades);
                    }
                }
            })
            .catch(error => console.log(error))
    }

    function handleClicCita(cita) {
        setDate(cita.fecha_cita);
        setTime(cita.hora_cita);
        setPrimerNombre(cita.primer_nombre);
        setSegundoNombre(cita.segundo_nombre);
        setPrimerApellido(cita.primer_apellido);
        setSegundoApellido(cita.segundo_apellido);
        setEmail(cita.email);
        setCelular(cita.celular);
        setTipoDocumento(cita.tipo_documento);
        setNumeroDocumento(cita.numero_documento);
        setIdPaciente(cita.id_paciente);
        setDuracionCita(cita.duracion_cita);
        setEstadoCita(cita.estado_cita);
        setIdEstadoCita(cita.id_estado_cita);
        setUnidadAtencion(cita.id_unidad_atencion);
        setMotivoConsulta(cita.motivo_consulta);
        setVerCita(true);
        setPrimeraVez(false);
        setIdCita(cita.id);
        setHoraAtencionCita(getElementosHora(cita.hora_cita)[0]);
        setMinutoCita(getElementosHora(cita.hora_cita)[1]);
        setAmpmCita(getElementosHora(cita.hora_cita)[2]);
        setProfesionalAsignado(cita.id_users);
        setIdUsuarioAgenda(cita.id_usuario_asigna);
        setNombreProfesionalAsignado(cita.nombre_profesional+' '+cita.apellido_profesional);
        setNombreUsuarioAsigna(cita.nombre_usuario_agenda+' '+cita.apellido_usuario_agenda);
        
        if (cita.estado=='1') {
            setPuedeAtender(true);
        }
        else {
            setPuedeAtender(false);
        }

        if (cita.estado_cita!=null) {
            setModalState('visible');
        }
    }


    function toastCita(msg) {
        
        setToastMsg(msg);
        setTimeout(() => { setShowToast(true) },800);
    }

    // Funciones para manejar filtros de unidades
    const toggleRecurso = (unidadId) => {
        setRecursosSeleccionados(prev => {
            if (prev.includes(unidadId)) {
                return prev.filter(id => id !== unidadId);
            } else {
                return [...prev, unidadId];
            }
        });
    };

    const seleccionarTodas = () => {
        const idsUnidades = todosLosRecursos.map(unidad => unidad.id_unidad || unidad.id);
        setRecursosSeleccionados(idsUnidades);
    };

    const deseleccionarTodas = () => {
        setRecursosSeleccionados([]);
    };

    const toggleMostrarFiltros = () => {
        setMostrarFiltros(!mostrarFiltros);
    };



    if (loggedIn) {

        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="calendar" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/agenda">Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Agenda por unidades</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Agenda por unidades</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-12">

                                <div className="row encabezado-agenda-recursos">
                                    <div className="col-md-3 navegacion-agenda-recursos fc-button-group">
                                        <button className="btn-atras" onClick={() => handleFecha(-1)}><span className="fc-icon fc-icon-chevron-left"></span></button>
                                        <button className="btn-adelante" onClick={() => handleFecha(1)}><span className="fc-icon fc-icon-chevron-right"></span></button>
                                    </div>
                                    <div className="col-md-3">
                                        <input 
                                            type="date" 
                                            className="form-control"
                                            value={fechaAgendaRecursos}
                                            onChange={(e) => handleFechaDirecta(e.target.value)}
                                            style={{fontSize: '14px'}}
                                        />
                                    </div>
                                    <div className="col-md-3 fecha-actual-agenda-recursos">{fechaAgendaRecursos}</div>
                                    <div className="col-md-3 text-right">
                                        <button 
                                            className="btn btn-outline-info btn-sm"
                                            onClick={toggleMostrarFiltros}
                                        >
                                            <i className="fas fa-filter"></i> Filtrar Unidades ({recursosSeleccionados.length}/{todosLosRecursos.length})
                                        </button>
                                    </div>
                                </div>

                                {/* Panel de Filtros */}
                                {mostrarFiltros && (
                                    <div className="card card-info card-outline mb-3">
                                        <div className="card-header">
                                            <h5 className="card-title">
                                                <i className="fas fa-filter"></i> Seleccionar Unidades a Mostrar
                                            </h5>
                                            <div className="card-tools">
                                                <button 
                                                    className="btn btn-sm btn-success mr-2"
                                                    onClick={seleccionarTodas}
                                                >
                                                    <i className="fas fa-check-double"></i> Todas
                                                </button>
                                                <button 
                                                    className="btn btn-sm btn-warning mr-2"
                                                    onClick={deseleccionarTodas}
                                                >
                                                    <i className="fas fa-times"></i> Ninguna
                                                </button>
                                                <button 
                                                    className="btn btn-sm btn-secondary"
                                                    onClick={toggleMostrarFiltros}
                                                >
                                                    <i className="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                {todosLosRecursos.map((unidad, index) => (
                                                    <div key={unidad.id_unidad || unidad.id} className="col-md-3 col-sm-4 col-6 mb-2">
                                                        <div className="d-flex align-items-center">
                                                            <CustomSwitch
                                                                onChange={() => toggleRecurso(unidad.id_unidad || unidad.id)}
                                                                checked={recursosSeleccionados.includes(unidad.id_unidad || unidad.id)}
                                                            />
                                                            <span className="ml-2" style={{ fontSize: '14px' }}>
                                                                {unidad.nombre_unidad && unidad.nombre_unidad.length > 20
                                                                    ? unidad.nombre_unidad.substring(0, 20) + '...'
                                                                    : unidad.nombre_unidad
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {todosLosRecursos.length === 0 && (
                                                <div className="text-center text-muted">
                                                    <i className="fas fa-info-circle"></i> No hay unidades disponibles para esta fecha
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                
                                <div className="contenedor-agenda-recursos" style={{height: alturaAgendaRecursos}}>
                                    <div className="etiquetas-hora" dangerouslySetInnerHTML={{ __html: etiquetasHoras }}></div>
                                    <div className="agenda-recursos" dangerouslySetInnerHTML={{ __html: bloquesMinutos }}>
                                        
                                    </div>
                                    {contenidoRecursos}
                                </div>

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>


                <FormNuevaCita 
                            modalState={modalState} 
                            closeModal={modalState => setModalState('hidden')} 
                            profesionalAsignado={profesionalAsignado}
                            nombreProfesionalAsignado={nombreProfesionalAsignado}
                            usuarioAsigna={usuarioAgenda}
                            nombreUsuarioAsigna={nombreUsuarioAsigna}
                            fecha={date}
                            hora={time}
                            reloadCitasAgenda={cargarCitas}
                            extendedProps={extendedProps}
                            primerNombre={primerNombre}
                            segundoNombre={segundoNombre}
                            primerApellido={primerApellido}
                            segundoApellido={segundoApellido}
                            email={email}
                            celular={celular}
                            tipoDocumento={tipoDocumento}
                            numeroDocumento={numeroDocumento}
                            duracionCita={duracionCita}
                            estadoCita={idEstadoCita}
                            unidadAtencion={unidadAtencion}
                            motivoConsulta={motivoConsulta}
                            verCita={verCita}
                            puedeAtender={puedeAtender}
                            idPaciente={idPaciente}
                            primeraVez={primeraVez}
                            idCita={idCita}
                            
                            horaAtencionCita={horaAtencionCita}
                            minutoCita={minutoCita}
                            ampmCita={ampmCita}

                            agendarCitaPaciente={props.agendarCitaPaciente}

                            bloquearProfesional={props.bloquearProfesional}

                            notificacionCita={toastCita}

                            stepCita={stepCita}
                            
                />
                
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default VistaPorUnidades;